import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import de from 'vuetify/es5/locale/de'
import en from 'vuetify/es5/locale/en'
import it from 'vuetify/es5/locale/it'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#5d6367',
    secondary: '#3f464a'
  },
  lang: {
    locales: { de, en, it },
    current: process.env.VUE_APP_I18N_LOCALE || 'en'
  }
})